import axios from "axios";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";
import { IoPrintOutline } from "react-icons/io5";
import {
  base_url,
  base_url as base_url_from_axios_config,
} from "../../utils/AxiosConfig";

const GratuityMonitor = () => {
  const location = useLocation();
  const [eosData, setEosData] = useState();
  const [currentGratuityPrintData, setCurrentGratuityPrintData] = useState();
  const [gratuityData, setGratuityData] = useState([]);

  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  const companyCode = storedUserDataArray[0]?.cmpcode || null;

  useEffect(() => {
    console.log("Location :", location.state.item);
    setEosData(location.state.item);
    fetchGratuityMonitorData(
      location.state.item?.EmpId,
      location.state.item?.EmpId.JOIN_DT,
      location.state.item?.EmpId.END_DATE,
    );
  }, [location]);

  const fetchGratuityMonitorData = async (empID, joinDATE, endDATE) => {
    try {
      const response = await axios.get(
        // "https://cubixweberp.com:213/api/CpaysGratuityMonitor/CUBIX/CBX002/1200/2018-01-01/2025-01-01",

        // `${base_url}/api/CpaysGratuityMonitor/${companyCode}/${empID}/1200/${joinDATE}/${endDATE}`,
        `${base_url}/api/CpaysGratuityMonitor/${companyCode}/${empID}/1200/2018-01-01/2025-01-01`,
      );

      console.log("Gratuity Monitor Data:", response.data[0]);
      setGratuityData(response.data[0]);
    } catch (error) {
      console.error("Error fetching gratuity monitor data:", error);
    }
  };

  const navigate = useNavigate();
  
  const onPrint = () => {
    console.log("Print is clicked");
    // navigate("/admin/gratuityMonitorPrint", { state: { item: gratuityData } });
    navigate("/admin/gratuityMonitorPrint", {
      state: {
        gratuityData,
        eosData,
      },
    });
  };

  const onBack = () => {
    navigate("/admin/endOfServiceApproval");
  };

  const totalPayable =
    (gratuityData?.Gratuity || 0) +
    (gratuityData?.SalaryBalance || 0) -
    (gratuityData?.LoanBalance || 0);

  return (
    <div className="w-full h-screen  p-4">
      {/* Header */}

      <div className="flex justify-between items-start ">
        <div className="flex justify-left items-center mb-4 ">
          <div className="w-1 h-8 bg-gradient-to-r from-[#2663EB] to-blue-400 rounded-full  mr-2"></div>
          <h6 className="text-xl font-bold text-gray-900 flex items-center gap-4">
            <span className="bg-gradient-to-r from-[#2663EB] to-blue-600 bg-clip-text text-transparent">
              GRATUITY MONITOR
            </span>
          </h6>
        </div>

        <div className="flex justify-center items-center gap-6">
          <button
            // onClick={onPrint(currentGratuityPrintData)}
            onClick={onPrint}
            className="flex items-center gap-2 bg-blue-700 hover:bg-blue-800 
                     text-white px-4 py-2 rounded-lg 
                     transition-all duration-200 
                     shadow-sm hover:shadow-md"
          >
            <IoPrintOutline className="text-lg" />
            Print
          </button>
          <button
            onClick={onBack}
            className="flex items-center gap-2 bg-gray-700 hover:bg-gray-800 
                     text-white px-4 py-2 rounded-lg 
                     transition-all duration-200 
                     shadow-sm hover:shadow-md"
          >
            <IoArrowBack className="text-lg" />
            Back
          </button>
        </div>
      </div>

      <div className="grid grid-cols-3 border bg-white">
        <div className="col-span-2 border-r p-2 shadow-md">
          <div className="grid grid-cols-2 gap-4 bg-gray-50 p-3 ">
            {/* <div>
              <p className="text-sm text-gray-600">Sl Code</p>
              <p className="font-semibold">{eosData?.serialcode}</p>
            </div> */}
            <div>
              <p className="text-sm text-gray-600">Employee ID</p>
              <p className="font-semibold">{eosData?.EmpId || eosData?.EmpId }</p>
            </div>

            <div>
              <p className="text-sm text-gray-600">Name</p>
              <p className="font-semibold">{eosData?.Name}</p>
            </div>

            <div>
              <p className="text-sm text-gray-600">Status</p>
              <p className="font-semibold">{eosData?.JobTitle}</p>
            </div>

            <div>
              <p className="text-sm text-gray-600">Separation Method</p>
              <p className="font-semibold">{eosData?.EOS_Type}</p>
            </div>
          </div>

          <div className="overflow-auto  border mt-2">
            <table className="w-full text-sm">
              <thead className=" sticky top-0 bg-[#2663EB]">
                <tr>
                  <th className="text-white px-2 py-1 text-left">EmpId</th>
                  <th className="text-white px-2 py-1 text-left">Name</th>
                  <th className="text-white px-2 py-1 text-left">JobTitle</th>
                  <th className="text-white px-2 py-1 text-left">EOS_Type</th>
                  <th className="text-white px-2 py-1 text-left">
                    Application
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr className="">
                  <td className="border px-2 py-1">{eosData?.EmpId}</td>
                  <td className="border px-2 py-1">{eosData?.Name}</td>
                  <td className="border px-2 py-1">{eosData?.JobTitle}</td>
                  <td className="border px-2 py-1">{eosData?.EOS_Type}</td>
                  <td className="border px-2 py-1">
                    {dayjs(eosData?.ApplicationDate).format("DD-MMM-YYYY")}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Right Panel */}
        <div className="p-4 bg-white shadow-md">
          <div className="space-y-3 text-sm">
            <div className="flex justify-between">
              <span>Join Date</span>
              <input
                // type="date"
                className="border px-2 py-1 rounded"
                defaultValue="2023-10-02"
                disabled
                value={dayjs(eosData?.JOIN_DT).format("DD-MMM-YYYY")}
              />
            </div>

            <div className="flex justify-between">
              <span>End Date</span>
              <input
                // type="date"
                className="border px-2 py-1 rounded"
                defaultValue="2025-12-31"
                disabled
                value={dayjs(eosData?.END_DATE).format("DD-MMM-YYYY")}
              />
            </div>

            <div className="flex justify-between">
              <span>Current Basic Salary</span>
              <span className="text-blue-600 font-semibold">
                {gratuityData?.BasicSalary}
              </span>
            </div>

            <div className="flex justify-between">
              <span>Daily Wage</span>
              <span className="text-blue-600 font-semibold">
                {gratuityData?.DailyWage}
              </span>
            </div>

            {/* <div className="flex justify-between">
              <span>Eligible Days</span>
              <span className="text-blue-600 font-semibold"></span>
            </div> */}
            <div className="flex justify-between">
              <span>Salary Account</span>
              <span className="text-blue-600 font-semibold">
                {gratuityData?.SalaryAccount}
              </span>
            </div>

            <div className="flex justify-between">
              <span>Loan Account</span>
              <span className="text-blue-600 font-semibold">
                {gratuityData?.LoanAccount}
              </span>
            </div>

            {/* Duration Box */}
            <div className=" p-2 flex justify-around bg-gray-50">
              <div>
                <p className="text-xs text-gray-500">Years</p>
                <p className="font-bold">{gratuityData?.YearsWorked}</p>
              </div>

              <div>
                <p className="text-xs text-gray-500">Months</p>
                <p className="font-bold">{gratuityData?.MonthsWorked}</p>
              </div>

              <div>
                <p className="text-xs text-gray-500">Days</p>
                <p className="font-bold">{gratuityData?.DaysWorked}</p>
              </div>
            </div>

            <div className="flex justify-between text-base font-semibold">
              <span>Eligible Gratuity</span>
              <span className="text-red-600">{gratuityData?.Gratuity}</span>
            </div>

            <div className="flex justify-between">
              <span>Salary Balance</span>
              <span className="text-red-600">
                {gratuityData?.SalaryBalance}
              </span>
            </div>

            <div className="flex justify-between">
              <span>Loans Balance</span>
              <span className="text-red-600">{gratuityData?.LoanBalance}</span>
            </div>

            <div className="flex justify-between bg-green-100 text-base p-2 font-semibold rounded">
              <span>Total Payable</span>
              <span className="text-red-600">{totalPayable}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GratuityMonitor;
